import { createFileRoute } from '@tanstack/react-router'
import ShareInvitePage from '@/pages/share/Invite'
import { useDocumentTitle } from 'usehooks-ts'
import { APP_NAME } from '@/lib/env'
export const Route = createFileRoute('/(auth)/share-invite')({
  component: RouteComponent,
  validateSearch: (search) => {
    // 校验 invitationId 是否存在或合法
    return {
      invitationId: search.invitationId as string | undefined,
    }
  },
})

function RouteComponent() {
  const { invitationId } = Route.useSearch()
  useDocumentTitle(`Invite - ${APP_NAME}`)

  return <ShareInvitePage invitationId={invitationId} />
}
